import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { ErrorMessage } from '@atlaskit/form';
import { FieldError } from '@atlassiansox/phobos-client-ts/src/models/FieldError';

import { RootStateContext } from '@/controllers';

const FormErrors: React.FC = () => {
  const {
    messages: { error: globalError },
  } = React.useContext(RootStateContext);

  if (!globalError) return null;

  return (
    <SectionMessage appearance="warning">
      {globalError?.fieldErrors?.map(fieldError => (
        <p key={fieldError.field}>
          &quot;<code>{fieldError.field}</code>&quot; {fieldError.error}
        </p>
      )) || globalError.message}
    </SectionMessage>
  );
};

// Form validation constants
export const VALUE_IS_REQUIRED = 'VALUE_IS_REQUIRED';
export const VALUE_IS_INVALID = 'VALUE_IS_INVALID';

export function formatFieldError(
  error: string,
  requiredErrorString?: string,
  invalidErrorString?: string
): string {
  if (error === VALUE_IS_REQUIRED) {
    return requiredErrorString || 'this value is required';
  }
  if (error === VALUE_IS_INVALID) {
    return invalidErrorString || 'this value is invalid';
  }
  return error;
}

export const ConditionalErrorMessage: React.FC<{
  error: string | undefined;
  requiredErrorString?: string;
  invalidErrorString?: string;
}> = ({ error, requiredErrorString, invalidErrorString }) => {
  if (error === undefined) {
    return <></>;
  }

  return (
    <ErrorMessage>{formatFieldError(error, requiredErrorString, invalidErrorString)}</ErrorMessage>
  );
};

// [ { field, error } ] => { [field]: error }
export function reduceFieldErrors(responseBody: {
  fieldErrors: Array<FieldError>;
}): { [key: string]: string } | undefined {
  const { fieldErrors } = responseBody;
  if (fieldErrors) {
    return fieldErrors.reduce(
      (acc: { [index: string]: string }, val: { field: string; error: string }) => {
        const { field, error: errStr } = val;
        acc[field] = errStr;
        return acc;
      },
      {}
    );
  }
  return undefined;
}

export default FormErrors;
